<template>
  <div class="menu">
    <div
      class="menu-children"
      :style="{'margin-top': index > 0 ? '4px' : '0px', 'background': selectId === item.id ? '#faeae7' : '#F6F6F6' }"
      v-for="(item, index) in dataList"
      :key="index"
      @click="selectMenu(item)"
    >
      <div
        :style="{'color': selectId === item.id ? '#F08A3E' : '#999'}"
        class="menu-children-name"
      >{{item.name}}</div>
      <div v-if="selectId !== item.id" class="menu-arrow">
        <img src="../../assets/grey-arrow.png" class="menu-children-arrow" />
      </div>
      <div v-else class="menu-arrow">
        <img src="../../assets/arrow.png" class="menu-children-arrow" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    selectId() {
      if (this.$route.query.selectThreeId) {
        return parseInt(this.$route.query.selectThreeId);
      } else {
        return this.$route.query.selectMoreId
          ? parseInt(this.$route.query.selectMoreId)
          : parseInt(this.$route.query.selectMenuId);
      }
    }
  },
  props: {
    dataList: Array
  },
  methods: {
    selectMenu(item) {
      this.$store.commit("eidtBreadcrumb", item.id);
      this.$http
        .get(
          `/open/cms/category?page=1&filter=parentId||eq||${item.id}&sort=rank,ASC`
        )
        .then(res => {
          if (res.data.data.length > 0 && this.selectId === item.id) {
            this.$router.push({
              name: "articleList",
              query: {
                selectMenuId: this.$route.query.selectMenuId,
                selectMoreId: item.id,
                selectThreeId: res.data.data[0].id,
                type: res.data.data[0].categoryType
              }
            });
          } else {
            this.$router.push({
              name: "articleList",
              query: {
                selectMenuId: this.$route.query.selectMenuId,
                selectMoreId: this.$route.query.selectThreeId
                  ? this.$route.query.selectMoreId
                  : item.id,
                selectThreeId: this.$route.query.selectThreeId ? item.id : "",
                type: item.categoryType
              }
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.menu {
  color: #939599;
  font-size: 16px;
  width: 284px;
  display: inline-block;
  padding: 4px;
  background: #fff;
  &-children {
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    &-name {
      float: left;
    }
    &-arrow {
      height: 14px;
      width: 7px;
    }
  }
  &-arrow {
    height: 40px;
    line-height: 40px;
    float: right;
    width: 10px;
  }
}
</style>
